import React from 'react'
import { Radio } from '@chakra-ui/react'
import { Box, Highlight, Text, Flex } from '@chakra-ui/react'

import { FormFieldsFragment } from '~graphql/generated/graphql'
import SharedLabel from '~components/shared/form/shared-label'
import OutlineBox from '~components/shared/wrappers/outline-box'
import SharedInfoText from '~components/shared/texts/shared-info-text'
import generatePublicFormLink from '~utils/helpers'
import SharedSelectableOption from '~components/shared/wrappers/shared-selectable-option'
import { FaLink } from 'react-icons/fa'
import { Icon } from '@chakra-ui/react'
import { BiDetail } from 'react-icons/bi'

interface Props {
    form: FormFieldsFragment
    isSelected: boolean
    onClick: () => void
    query: string
}

export default function FormOption({ form, isSelected, onClick }: Props) {
    const { name } = form
    const url = generatePublicFormLink(form.id)

    return (
        <SharedSelectableOption
            label={name || 'Untitled Form'}
            helpText={url}
            isSelected={isSelected}
            onClick={onClick}
            leftFlair={
                <Icon mr={4} color="brand.500" boxSize="16px" as={BiDetail} />
            }
        />
    )
}
